import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito saber de astrología para usar esto?',
    a: 'No. Todo está explicado en lenguaje claro y directo. No necesitás ningún conocimiento previo. Si sabés la fecha de nacimiento de tu hijo, podés empezar.'
  }, {
    q: '¿Para qué edad sirve?',
    a: 'Para niños de 0 a 12 años. Cada tomo tiene orientaciones para diferentes etapas de desarrollo.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Es 100% digital. Apenas completás tu compra recibís un email con el link de descarga inmediata.'
  }, {
    q: '¿Y si no me sirve?',
    a: 'Tenés 7 días de garantía total. Si no quedás satisfecha te devolvemos el dinero completo sin preguntas.'
  }, {
    q: '¿Puedo usarlo para más de un hijo?',
    a: 'Sí. Podés aplicar el sistema con cada uno de tus hijos con la misma compra.'
  }, {
    q: '¿Por qué cuesta solo $11 si tiene tanto valor?',
    a: 'Porque queremos que ninguna mamá se quede sin acceso a esta información por una cuestión económica. Este es nuestro precio de lanzamiento y no va a durar.'
  }];
  return <section className="py-10 px-4 bg-cream-100" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <FadeIn data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-burgundy-900 mb-12" data-id="element-24">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
              <div className="bg-white rounded-2xl border border-cream-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-27">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-28">
                  <span className="font-bold text-burgundy-900 text-lg pr-4" data-id="element-29">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0 text-dusty-rose-500" data-id="element-30">
                    <ChevronDown className="w-6 h-6" data-id="element-31" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-32">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-33">
                      <div className="px-6 pb-5 text-burgundy-700 leading-relaxed border-t border-cream-50 pt-4" data-id="element-34">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}